import DefaultButton from '@/components/common/DefaultButton';
import PrimaryButton from '@/components/common/PrimaryButton';
import DriveUploadDialog from '@/pages/ProjectVideo/DriveUploadingDialog';
import JwpUploadDialog from '@/pages/ProjectVideo/JwpUploadingDialog';
import ShareDialog from '@/pages/ProjectVideo/ShareDialog/ShareDialog';
import { ButtonsContainer } from '@/pages/ProjectVideo/styles';
import WowzaUploadDialog from '@/pages/ProjectVideo/WowzaUploadDialog';
// import { PROJECT_TRANSCRIPT_URL, PROJECT_VIDEO_TRANSCRIPT_URL } from '@/routePaths';
import { Box, CircularProgress } from '@mui/material';
import { FC, useState } from 'react';
// import { generatePath, useNavigate } from 'react-router-dom';

interface VideoActionsProps {
  platforms: {
    wowza?: boolean;
    jwp?: boolean;
    drive?: boolean;
    s3?: boolean;
  };
  saveChanges(): void;
  status?: boolean;
  onGenerateTranscript(): void;
}

const VideoActions: FC<VideoActionsProps> = ({
  platforms,
  saveChanges,
  status,
  onGenerateTranscript,
}) => {
  // const navigate = useNavigate();
  const [isShareDialogOpen, setIsShareDialogOpen] = useState<boolean>(false);
  const [isWowzaUploadDialogOpen, setIsWowzaUploadDialogOpen] = useState<boolean>(false);
  const [isJwpUploadDialogOpen, setIsJwpUploadDialogOpen] = useState<boolean>(false);
  const [isDriveUploadDialogOpen, setIsDriveUploadDialogOpen] = useState<boolean>(false);

  // const viewTranscript = (): void => {
  //   if (!project) {
  //     return;
  //   }
  //   const videoId = null;

  //   const pathArray = window.location.pathname.split('/');
  //   const segId = pathArray[pathArray.length - 1];
  //   if (videoId) {
  //     navigate(
  //       generatePath(PROJECT_VIDEO_TRANSCRIPT_URL, {
  //         projectId: project.id,
  //         videoId,
  //         segmentId: segId,
  //       }),
  //     );
  //   } else {
  //     navigate(generatePath(PROJECT_TRANSCRIPT_URL, { projectId: project.id, segId }));
  //   }
  // };

  const share = (): void => {
    setIsShareDialogOpen(true);
  };

  return (
    <Box>
      <ButtonsContainer>
        {status ? (
          <div style={{ display: 'flex', alignItems: 'center', margin: '12px' }}>
            <CircularProgress size={16} sx={{ marginRight: 1 }} /> Processing
          </div>
        ) : (
          <PrimaryButton size="small" rounded onClick={saveChanges} data-voice-action="save">
            {'Save Changes'}
          </PrimaryButton>
        )}
        <DefaultButton
          size="small"
          rounded
          onClick={onGenerateTranscript}
          data-voice-action="transcript"
        >
          Transcript
        </DefaultButton>
        <DefaultButton size="small" rounded onClick={share} data-voice-action="share">
          Share
        </DefaultButton>
      </ButtonsContainer>
      <ShareDialog
        open={isShareDialogOpen}
        wowza={platforms.wowza}
        jwp={platforms.jwp}
        drive={platforms.drive}
        onShareByWowza={() => {
          setIsShareDialogOpen(false);
          setIsWowzaUploadDialogOpen(true);
        }}
        onShareByJwp={() => {
          setIsShareDialogOpen(false);
          setIsJwpUploadDialogOpen(true);
        }}
        onShareByDrive={() => {
          setIsShareDialogOpen(false);
          setIsDriveUploadDialogOpen(true);
        }}
        onClose={() => setIsShareDialogOpen(false)}
      ></ShareDialog>
      <WowzaUploadDialog
        open={isWowzaUploadDialogOpen}
        onClose={() => setIsWowzaUploadDialogOpen(false)}
      ></WowzaUploadDialog>
      <JwpUploadDialog
        open={isJwpUploadDialogOpen}
        onClose={() => setIsJwpUploadDialogOpen(false)}
      ></JwpUploadDialog>
      <DriveUploadDialog
        open={isDriveUploadDialogOpen}
        onClose={() => setIsDriveUploadDialogOpen(false)}
      ></DriveUploadDialog>
    </Box>
  );
};

export default VideoActions;
